var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArnakd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9494ED",
    d: "M21.716 0H1.06C.848 0 .65.062.484.17.392.23.311.303.241.388.09.57 0 .805 0 1.059v15.36c0 .585.475 1.06 1.06 1.06h20.656c.584 0 1.06-.475 1.06-1.06V1.06C22.775.475 22.3 0 21.715 0",
    transform: "translate(.348 .347)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M23.768 6.091H17.94c-.585 0-1.059.474-1.059 1.06v3.177c0 .585.474 1.06 1.06 1.06h5.826c.585 0 1.06-.475 1.06-1.06V7.15c0-.585-.475-1.059-1.06-1.059m-4.464 3.84c-.659 0-1.193-.533-1.193-1.192 0-.658.534-1.192 1.193-1.192.658 0 1.192.534 1.192 1.192 0 .659-.534 1.192-1.192 1.192",
    transform: "translate(.348 .347)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9494ED",
    d: "M20.483 8.733c0 .656-.53 1.186-1.185 1.186s-1.186-.53-1.186-1.186c0-.655.53-1.185 1.186-1.185.654 0 1.185.53 1.185 1.185",
    transform: "translate(.348 .347)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArnakd);
export default __webpack_public_path__ + "static/media/arnakd.705179c12c6c3bb89d7059245afbe123.svg";
export { ForwardRef as ReactComponent };